import React, { Component } from "react";
import { connect } from "react-redux";

import MerchantListViewContainer from "./merchantListViewContainer";
import MerchantSearchContainer from "./merchantSearchContainer";
import HelpTextContainer from "./helpTextContainer";

class ImpersonationContainer extends Component {
  render() {
    const merchants = this.props.impersonation.merchants;

    return this.props.endpoints ? (
      <div style={{ width: "800px", margin: "160px auto" }}>
        <h1 className="text-center">Supportal</h1>
        <MerchantSearchContainer {...this.props} />
        {!merchants ? <HelpTextContainer /> : null}
        <MerchantListViewContainer {...this.props} />
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => {
  return {
    endpoints: state.get("config").toJS().endpoints,
    impersonation: state.get("impersonation").toJS(),
  };
};

export default connect(mapStateToProps)(ImpersonationContainer);
